import useWebSocketStore from "../store/webSocketStore";
import { classNames } from "../utils/appUtils";
import { Text } from "./catalyst/text";

export const WsConnectionStatus = () => {
  const { socketState } = useWebSocketStore();

  const getStatusColor = () => {
    switch (socketState) {
      case 0:
        return "bg-yellow-500";
      case 1:
        return "bg-green-500";
      case 2:
        return "bg-gray-500";
      case 3:
        return "bg-red-500";
      default:
        return "bg-gray-500";
    }
  };

  const getStatusText = () => {
    switch (socketState) {
      case 0:
        return "Connecting";
      case 1:
        return "Connected";
      case 2:
        return "Unknown";
      case 3:
        return "Disconnected";
      default:
        return "Unknown";
    }
  };

return (
    <div className="flex items-center">
        <div
            className={classNames("w-3 h-3 rounded-full mr-2 animate-pulse", getStatusColor())}
        />
        <Text>{getStatusText()}</Text>
    </div>
);
};
